import OfflineMonitor from '@ps-int/ufo-rocks/lib/helpers/offline';

const offlineMonitor = new OfflineMonitor();

export default {
    addOfflineEventListener(callback: () => void) {
        offlineMonitor.addOfflineEventListener(callback);
    },
    addOnlineEventListener(callback: () => void) {
        offlineMonitor.addOnlineEventListener(callback);
    },
    removeOfflineEventListener(callback: () => void) {
        offlineMonitor.removeOfflineEventListener(callback);
    },
    removeOnlineEventListener(callback: () => void) {
        offlineMonitor.removeOnlineEventListener(callback);
    },
    pingUntilOnline(): Promise<boolean> {
        return offlineMonitor.pingUntilOnline();
    },
};
